function faq_data_deployment(list, pageName) {
  if (!list || list.length === 0) {
    return [];
  }

  // 假设这是从后端获取的 FAQ 数据
  let faqData = list
  let pageNameType = pageName ? pageName : 'FAQPage'

  function format_text(text) {
    if (!text) return '';
  
    // 保留允许的 HTML 标签
    // 这些标签会被保留在最终的文本中
    const allowedTags = /<\/?(h1|h2|h3|h4|h5|h6|br|ol|ul|li|a|p|div|b|strong|i|em)[^>]*>/gi;
  
    // 删除所有不在 allowedTags 中的标签
    return text.replace(/<\/?([^>]+)>/gi, (match, tag) => {
      // 如果标签在允许的标签列表中，保留它，否则删除
      if (allowedTags.test(match)) {
        return match;
      } else {
        return '';  // 删除不允许的标签
      }
    });
  }
  

  // 动态生成 FAQ 数据
  function data_formatting(list) {
    if (!list || list.length === 0) {
      return [];
    }

    return list.map((item) => ({
      "@type": "Question",
      "name": item.title ? item.title : '',
      "acceptedAnswer": {
        "@type": "Answer",
        "text": format_text(item.description),
      },
    }));
  }

  // 生成 JSON-LD 数据
  const faqJsonLd = {
    "@context": "https://schema.org",
    "@type": pageNameType,
    "mainEntity": data_formatting(faqData),
  };

  // 将 JSON-LD 数据插入到页面中
  const script = document.createElement("script");
  script.type = "application/ld+json";
  script.textContent = JSON.stringify(faqJsonLd);
  document.head.appendChild(script);
}